(() => {
  'use strict';

  /* ---------------- CART DRAWER ---------------- */

  function openCartDrawer() {
    const cartLink =
      document.querySelector('a[data-js-cart-icon]') ||
      document.querySelector('a[href*="/cart"]');

    if (cartLink) cartLink.click();
  }

  async function addToCartByVariantId(variantId, qty = 1) {
    const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] }),
    });

    if (!res.ok) {
      let msg = 'Sepete eklenemedi.';
      try {
        const j = await res.json();
        if (j?.description) msg = j.description;
      } catch (e) {}
      throw new Error(msg);
    }
    return res.json();
  }

  async function refreshCartCount() {
    try {
      const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {
        credentials: 'include',
      });
      if (!res.ok) return;
      const cart = await res.json();
      document.querySelectorAll('[data-js-cart-count]').forEach((el) => {
        el.textContent = String(cart.item_count ?? 0);
      });
    } catch (e) {}
  }

  /* ---------------- QUICK VIEW MODAL ---------------- */

  async function openQuickViewModal(productUrl) {
    if (document.querySelector('.mg-quick-view-overlay')) return;

    const url = new URL(productUrl, window.location.origin);
    url.searchParams.set('section_id', 'quick-view');

    const res = await fetch(url.toString(), { credentials: 'include' });
    if (!res.ok) {
      window.location.href = productUrl;
      return;
    }

    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const section = doc.querySelector('.shopify-section');

    if (!section) {
      window.location.href = productUrl;
      return;
    }

    const overlay = document.createElement('div');
    overlay.className = 'mg-quick-view-overlay';
    overlay.innerHTML = `
      <div class="mg-quick-view-backdrop"></div>
      <div class="mg-quick-view-modal">
        <button class="mg-quick-view-close" aria-label="Close">×</button>
        ${section.innerHTML}
      </div>
    `;

    document.body.appendChild(overlay);
    document.body.classList.add('mg-quick-view-open');

    function close() {
      overlay.remove();
      document.body.classList.remove('mg-quick-view-open');
      document.removeEventListener('keydown', esc);
    }

    function esc(e) {
      if (e.key === 'Escape') close();
    }

    overlay.querySelector('.mg-quick-view-backdrop').addEventListener('click', close);
    overlay.querySelector('.mg-quick-view-close').addEventListener('click', close);
    document.addEventListener('keydown', esc);
  }

  /* ---------------- FREE SHIPPING BAR ---------------- */

  async function refreshFreeShippingBarSection() {
    const currentBar = document.querySelector('[data-free-shipping-bar]');
    if (!currentBar) return;

    const url = new URL(window.location.href);
    url.searchParams.set('section_id', 'free-shipping-bar');

    try {
      const res = await fetch(url.toString(), { credentials: 'include' });
      if (!res.ok) return;

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newBar = doc.querySelector('[data-free-shipping-bar]');
      if (!newBar) return;

      currentBar.replaceWith(newBar);
    } catch (e) {
      console.error('Free shipping bar refresh failed', e);
    }
  }

  /* ===============================
     MOBILE SWIPE FIX
     =============================== */

  function enableTouchSwipe(track) {
    let startX = 0;
    let startY = 0;
    track.__mgDragging = false;

    track.addEventListener(
      'touchstart',
      (e) => {
        if (!e.touches || e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        track.__mgDragging = false;
      },
      { passive: true }
    );

    track.addEventListener(
      'touchmove',
      (e) => {
        if (!e.touches || e.touches.length !== 1) return;

        const dx = e.touches[0].clientX - startX;
        const dy = e.touches[0].clientY - startY;

        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 6) {
          track.__mgDragging = true;
          track.scrollLeft -= dx;
          startX = e.touches[0].clientX;
          e.preventDefault();
        }
      },
      { passive: false }
    );

    track.addEventListener(
      'touchend',
      () => {
        // click hemen gelmesin diye
        setTimeout(() => {
          track.__mgDragging = false;
        }, 80);
      },
      { passive: true }
    );
  }

  /* ---------------- SLIDER INIT ---------------- */

  function initOne(root) {
    if (!root || root.dataset.mgMiniInit === '1') return;

    const track = root.querySelector('[data-mg-track]');
    const prev = root.querySelector('.mg-mini-arrow--prev');
    const next = root.querySelector('.mg-mini-arrow--next');
    if (!track || !prev || !next) return;

    root.dataset.mgMiniInit = '1';

    // ✅ mobile swipe devreye girsin
    enableTouchSwipe(track);

    const firstItem = track.querySelector('.mg-mini-manuel-item');
    const cardWidth = firstItem ? firstItem.getBoundingClientRect().width : 260;

    let gap = 12;
    try {
      const cs = window.getComputedStyle(track);
      const g = parseFloat(cs.columnGap || cs.gap || '12');
      if (!Number.isNaN(g)) gap = g;
    } catch (e) {}

    const STEP = cardWidth + gap;

    function updateArrows() {
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
    }

    prev.addEventListener('click', () => track.scrollBy({ left: -STEP, behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: STEP, behavior: 'smooth' }));
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    /* -------- CLICK INTERCEPT -------- */

    root.addEventListener('click', async (e) => {
      // ✅ swipe sırasında click’i tamamen iptal et
      if (track.__mgDragging) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      /* IMAGE / TITLE LINK */
      const link = e.target.closest('a[href*="/products/"]');
      if (link && root.contains(link)) {
        const item = link.closest('.mg-mini-manuel-item');
        if (!item) return;

        const variantCount = Number(item.dataset.variantCount || 0);
        const productUrl = link.getAttribute('href');

        if (variantCount > 1) {
          e.preventDefault();
          e.stopPropagation();
          openQuickViewModal(productUrl);
          return;
        }
      }

      /* QUICK ADD */
      const btn = e.target.closest('[data-quick-shop-trigger="quick-add"]');
      if (!btn || !root.contains(btn)) return;

      const variantId = btn.dataset.productId;
      if (!variantId) return;

      e.preventDefault();

      btn.classList.add('loading');
      btn.setAttribute('aria-busy', 'true');

      try {
        // optional: theme bazı yerlerde bunu dinliyor olabilir
        document.dispatchEvent(new CustomEvent('cart:updating'));

        await addToCartByVariantId(variantId, 1);

        // 🔑 KRİTİK: quick-cart drawer loading state’ini kapat + refresh tetikle
        document.dispatchEvent(new Event('apps:product-added-to-cart'));

        await refreshCartCount();
        openCartDrawer();
        await refreshFreeShippingBarSection();

        // optional: cart data publish (bazı komponentler kullanır)
        try {
          const res = await fetch('/cart.js', { credentials: 'include' });
          if (res.ok) {
            const cart = await res.json();
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            document.dispatchEvent(new CustomEvent('quick-cart:updated'));
          }
        } catch (e) {}
      } catch (err) {
        alert(err?.message || 'Sepete eklenemedi.');
      } finally {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-busy');
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.mg-mini-manuel-slider').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.('.mg-mini-manuel-slider')) initOne(node);
        node.querySelectorAll?.('.mg-mini-manuel-slider').forEach(initOne);
      }
    }
  });

  mo.observe(document.documentElement, { childList: true, subtree: true });
})();